/// <reference path="skyward.base.js"/>
/// <reference path="skyward.ui.controls.ts"/>
skyward.base.registerScript('specialeducationmi', function (skyward, $)
{
    "use strict";

    function initEarlyChildhoodAssessment(context)
    {
        var register = function (prefix)
        {
            var showHideOtherToolComments = function ()
            {
                var fieldset = $(prefix + 'OtherToolComment');

                if ($(prefix + 'DescriptorCodeIDAssessmentTool_code').val() === '18')
                {
                    skyward.controls.show(fieldset.closest('fieldset'));
                }
                else
                {
                    skyward.controls.hide(fieldset.closest('fieldset'));
                    skyward.controls.clearValue(fieldset);
                }
            };

            showHideOtherToolComments();
            $(prefix + 'DescriptorCodeIDAssessmentTool').on('eelComplete', showHideOtherToolComments);
        }

        register('#EarlyChildhoodAssessmentMI');
        register('#editEarlyChildhoodAssessmentMI_');
    }

    function initEvaluation(context)
    {
        var register = function (prefix)
        {
            var exitDateFieldSet = $(prefix + 'ExitDate');
            var updateEndDate = function ()
            {
                var endDateFieldSet = $(prefix + 'EndDate');
                var exitDateValue = skyward.controls.getValue(exitDateFieldSet);
                skyward.controls.setValue(endDateFieldSet, exitDateValue);
            };

            exitDateFieldSet.on('change', updateEndDate);
        };

        register('#EvaluationMI');
        register('#editEvaluationMI_');
    }

    function initTotalInstructionalMinutes(context)
    {
        var totalInstructionalMinutes = function ()
        {
            var instructionalHoursValue = $('.js-InstructionalHours').val();
            var instructionalMinutesValue = $('.js-InstructionalMinutes').val();

            skyward.controls.setValue('.js-InstructionalTotal', (instructionalHoursValue ? instructionalHoursValue : 0) * 60 + parseInt(instructionalMinutesValue ? instructionalMinutesValue : 0));
        };

        $('.js-InstructionalHours').on('change', totalInstructionalMinutes);
        $('.js-InstructionalMinutes').on('change', totalInstructionalMinutes);
    }

    function initServiceTimeCalculation(context)
    {
        var directTimeCalculation = function ()
        {
            //scope to the containing div to handle multiple instances of the field group on one screen
            var directTimeHours = $(this).parent().find('.js-directHours').val();
            var directTimeMinutes = $(this).parent().find('.js-directMinutes').val();

            skyward.controls.setValue($(this).parent().find('.js-directTotal'), (directTimeHours ? directTimeHours : 0) * 60 + parseInt(directTimeMinutes ? directTimeMinutes : 0));
        };

        var indirectTimeCalculation = function ()
        {
            var indirectTimeHours = $(this).parent().find('.js-indirectHours').val();
            var indirectTimeMinutes = $(this).parent().find('.js-indirectMinutes').val();

            skyward.controls.setValue($(this).parent().find('.js-indirectTotal'), (indirectTimeHours ? indirectTimeHours : 0) * 60 + parseInt(indirectTimeMinutes ? indirectTimeMinutes : 0));
        };

        $('.js-directHours').on('change', directTimeCalculation);
        $('.js-directMinutes').on('change', directTimeCalculation);
        $('.js-indirectHours').on('change', indirectTimeCalculation);
        $('.js-indirectMinutes').on('change', indirectTimeCalculation);
    }

    var events =
    {
        "initEarlyChildhoodAssessment": initEarlyChildhoodAssessment,
        "initEvaluation": initEvaluation,
        "initTotalInstructionalMinutes": initTotalInstructionalMinutes,
        "initServiceTimeCalculation": initServiceTimeCalculation,
    };

    return events;
});
//# sourceURL=skyward.ui.specialeducationmi.js